export enum SendGridTab {
  Credentials = 'credentials',
  Templates = 'templates',
}
